import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL

const getPlanosTrabalhoPorModalidade = async (token: string, modalidade: string, page: number = 1) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    }
  };
  const response = await axios.get(`${API_URL}/planos-de-trabalho/modalidade/${modalidade}?page=${page}`, config);
  return response.data;
};

export default getPlanosTrabalhoPorModalidade;